import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { queryStringToObject, validationErrorsToString } from '../../utils';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { useHistory } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import CircleImage from '../../components/CircleImage';
import LoadingSpinner from '../../components/LoadingSpinner';
import Button from '../../components/Button';

// TYPES
interface LinkAccountTypes {}
import { AccountLinkRequestApproveCommand, AccountLinkRequestRejectCommand } from '../../api/models';

const LinkAccount: React.FC<LinkAccountTypes> = ({}) => {
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>();

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	const [parentName, setParentName] = React.useState<string>('');

	const history = useHistory();

	const organisationName = useAppSelector(
		(state) => state.user.profiles?.filter((profile) => profile.isOrganisationActive)[0].name
	);

	const organisationImage = useAppSelector(
		(state) => state.user.profiles?.filter((profile) => profile.isOrganisationActive)[0].image
	);

	// Getting the Ids from Params and query
	const queryParams = queryStringToObject();
	const requestingProfileId = queryParams.id;

	const getLinkRequestName = async () => {
		setIsLoading(true);

		const response = await apibridge.getAccountLinkRequest(requestingProfileId);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else if (response.result) {
			const { result = {} } = response;
			setIsLoading(false);

			setParentName(result.parentName || '');
		}
	};

	React.useEffect(() => {
		if (requestingProfileId) {
			getLinkRequestName();
		}

		setIsLoading(false);
	}, []);

	const acceptInvitation = async () => {
		setIsLoading(true);

		const data: AccountLinkRequestApproveCommand = { id: requestingProfileId };

		const response = await apibridge.postAccountLinkRequestApprove(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			history.push('/link-success');
		}
	};

	const rejectInviation = async () => {
		setIsLoading(true);

		const data: AccountLinkRequestRejectCommand = { id: requestingProfileId };

		const response = await apibridge.postAccountLinkRequestReject(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			history.push('/link-success');
		}
	};

	return (
		<div className="page-link-account">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<div className="header row">
									<div className="section-header col-lg-4 col-md-6 col-12">
										<CircleImage extraClass="center-image" size={82} src={organisationImage} />

										<h1>
											{parentName} has invited you to link accounts with {organisationName}
										</h1>

										<div className="button-container col-10">
											<Button onClick={() => acceptInvitation()} type="button" className="btn btn-primary full-width">
												Accept invitation
											</Button>

											<Button onClick={() => rejectInviation()} type="button" className="btn btn-secondary full-width">
												Decline invitation
											</Button>
										</div>
									</div>
								</div>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default LinkAccount;
